import { Box, Button, VStack, Text } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';
import type { FormEvent } from 'react';
import { CodeInput } from './components/CodeInput';
import { useLoginCode } from './hooks/useLoginCode';

interface LoginCodeProps {
   email: string;
   onNavigateBack: () => void;
}

export const LoginCode = ({ email, onNavigateBack }: LoginCodeProps) => {
   const { code, setCode, isSubmitting, error, submitCode } = useLoginCode({
      email,
      onNavigateBack,
   });
   const codeInputId = 'login-code-input';

   const handleSubmit = (e: FormEvent) => {
      e.preventDefault();
      void submitCode();
   };

   return (
      <Box fontSize="16px" width={{ base: '100%', md: '384px' }}>
         <VStack
            className="login-code-wrapper"
            flexDirection="column"
            spacing={6}
            paddingY={8}
            paddingX={6}
            bgColor="white"
            borderWidth={1}
            borderRadius="base"
         >
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
               <Box textAlign="center" color="gray.600">
                  {_js('A 6-digit login code has been sent to: ')}
                  <Box as="span" fontWeight="medium">
                     {email}
                     <Button
                        variant="link"
                        marginLeft={2}
                        color="brand.500"
                        onClick={onNavigateBack}
                        isDisabled={isSubmitting}
                     >
                        ({_js('change')})
                     </Button>
                  </Box>
               </Box>
               <VStack spacing={6}>
                  <Box width="100%">
                     <CodeInput value={code} onChange={setCode} inputId={codeInputId} />
                     {error && (
                        <Text color="red.500" mt={2} fontSize="sm">
                           {error}
                        </Text>
                     )}
                  </Box>
                  <Button
                     variant="cta"
                     width="full"
                     type="submit"
                     isLoading={isSubmitting}
                     loadingText={_js('Verifying...')}
                  >
                     {_js('Login')}
                  </Button>
               </VStack>
            </form>
         </VStack>
      </Box>
   );
};
